import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { TransactionListDurationCell } from '@app/feature/transaction/transaction-list/transaction-list-duration.cell';
import { TransactionListDurationHeader } from '@app/feature/transaction/transaction-list/transaction-list-duration.header';

export const TokenTransactionListDurationColumn: DisplayColumnDef<
  TransactionModel,
  unknown
> = {
  id: 'duration',
  enableSorting: false,
  header: TransactionListDurationHeader,
  cell: TransactionListDurationCell,
};
